import { useState, useEffect, useRef, useCallback } from "react";
 
const WA_MSG = encodeURIComponent("Hello, I would like to inquire about your land surveying services.");
const WA_URL = `https://wa.me/918507226854?text=${WA_MSG}`;
const PHONE  = "tel:+918507226854";
const PHONE_DISPLAY = "+91 85072 26854";
const NAV_LINKS = ["Home","About","Services","Features","Testimonials","Contact"];
 
const SERVICES = [
  { icon:"🗺️", title:"Land Survey", desc:"Precise boundary surveys using modern instruments and traditional expertise across all terrains.", grad:"from-blue-600 to-blue-700" },
  { icon:"📐", title:"Property Measurement", desc:"Accurate area calculation and dimension verification for residential and commercial properties.", grad:"from-emerald-600 to-emerald-700" },
  { icon:"🧭", title:"Plot Mapping", desc:"Detailed topographic and cadastral mapping with legal documentation support.", grad:"from-blue-700 to-indigo-700" },
  { icon:"📋", title:"Boundary Verification", desc:"Official boundary demarcation with physical markers and GPS coordinate recording.", grad:"from-teal-600 to-teal-700" },
];
 
const FEATURES = [
  { icon:"⚡", title:"Fast Service", desc:"Quick turnaround on all survey assignments without compromising accuracy." },
  { icon:"🎯", title:"Accurate Measurement", desc:"100% precision guaranteed with multiple verification checks on every project." },
  { icon:"🤝", title:"Trusted Work", desc:"5000+ satisfied clients across Bihar place their trust in us every year." },
  { icon:"📜", title:"Legal Compliance", desc:"All surveys conform to Bihar land revenue laws and government specifications." },
  { icon:"🛰️", title:"GPS Technology", desc:"State-of-the-art GPS equipment for sub-centimeter accuracy in measurements." },
  { icon:"📞", title:"24/7 Support", desc:"Round-the-clock availability for urgent survey requirements and client queries." },
];
 
const TESTIMONIALS = [
  { name:"Rajesh Sharma", role:"Property Owner, Patna", text:"Shambhu Kumar ji resolved a 10-year boundary dispute in just 2 days. His expertise and professionalism are unmatched in the region.", rating:5 },
  { name:"Sunita Devi", role:"Farmer, Lakhisarai", text:"We were confused about our agricultural land boundaries. His team came quickly, measured everything correctly, and gave us clear documentation.", rating:5 },
  { name:"Amit Kumar Singh", role:"Builder, Munger", text:"For all our construction projects in Bihar, we always call Shambhu Kumar ji first. 30 years of experience really shows in every survey.", rating:5 },
  { name:"Priya Gupta", role:"Homeowner, Begusarai", text:"The plot verification was done with great precision. All legal documents were prepared correctly. Highly recommend for property transactions.", rating:5 },
  { name:"Ram Prasad", role:"Contractor, Nalanda", text:"Reliable, honest, and always on time. Have used his services for 5+ projects. Best land surveyor in entire Bihar region.", rating:5 },
];
 
const STATS = [
  { end:5000, suffix:"+", label:"Projects Completed" },
  { end:30,   suffix:"+", label:"Years Experience"   },
  { end:1200, suffix:"+", label:"Happy Clients"      },
  { end:100,  suffix:"%", label:"Accuracy Rate"      },
];
 
/* ── TRANSLATIONS ── */
const T = {
  en: {
    navLinks: ["Home","About","Services","Features","Testimonials","Contact"],
    heroTag: "Licensed Amin · Bihar Revenue Dept.",
    heroSub: "30+ years of trusted experience in land surveying across Bihar. Accurate measurements, legal compliance, and reliable service guaranteed for every property.",
    heroCta1: "WhatsApp Now",
    heroCta2: "Call Now",
    heroMini: [["5000+","Projects"],["30+","Years"],["100%","Accurate"],["Bihar","Licensed"]],
    heroTyping: ["Land Survey","Property Mapping","Boundary Marking","Plot Verification"],
    heroExpertIn: "Expert in",
    aboutTag: "Who We Are",
    aboutTitle: "About",
    aboutSub: "A legacy of precision, trust, and professional excellence in land surveying",
    aboutName: "Shambhu Kumar",
    aboutRole: "Licensed Land Surveyor (Amin)",
    aboutHeading: "Bihar's Most Trusted Land Surveyor",
    aboutP1: (y) => <>With over <strong className="text-blue-500">{y} years</strong> of dedicated service, Shambhu Kumar (Amin) has established himself as the most reliable land surveyor in Bihar, with expertise in land measurement, property verification, and legal documentation.</>,
    aboutP2: "Licensed by the Bihar Revenue Department, he brings precision, integrity, and speed to every assignment — from simple plot measurements to complex multi-parcel land surveys.",
    aboutBadges: [["🏆","Govt. Licensed Amin"],["📍","Lakhisarai, Bihar"],["⚖️","Revenue Dept. Certified"],["🌏","Pan-Bihar Service"]],
    svcTag: "What We Do", svcTitle: "Our", svcTitleSpan: "Services",
    svcSub: "Comprehensive land surveying solutions for individuals, builders, and government bodies",
    featTag: "Why Choose Us", featTitle: "Our", featTitleSpan: "Advantages",
    testiTag: "Client Stories", testiTitle: "What", testiTitleSpan: "Clients Say",
    contactTag: "Get In Touch", contactTitle: "Contact", contactTitleSpan: "Us",
    contactInfo: "Contact Information",
    contactSubText: "Reach out through any channel below.",
    tapCall: "Tap to Call", chatWA: "Chat on WhatsApp", emailLbl: "Email", addrLbl: "Office Address",
    addrText: <>Shambhu Kumar – Licensed Land Surveyor (Amin)<br/> Shanti Kunj Bhawan , Krishna Nagar<br/>Ward No. 2, Vidyapith Chowk<br/>Lakhisarai, Bihar 811311, India</>,
    sendMsg: "Send a Message",
    namePh: "Your Full Name *", phonePh: "Phone Number *", emailPh: "Email (optional)", msgPh: "Your message or inquiry *",
    sendBtn: "Send via WhatsApp", sentMsg: "✅ Message Sent!",
    statLabels: ["Projects Completed","Years Experience","Happy Clients","Accuracy Rate"],
    services: [
      { icon:"🗺️", title:"Land Survey", desc:"Precise boundary surveys using modern instruments and traditional expertise across all terrains.", grad:"from-blue-600 to-blue-700" },
      { icon:"📐", title:"Property Measurement", desc:"Accurate area calculation and dimension verification for residential and commercial properties.", grad:"from-emerald-600 to-emerald-700" },
      { icon:"🧭", title:"Plot Mapping", desc:"Detailed topographic and cadastral mapping with legal documentation support.", grad:"from-blue-700 to-indigo-700" },
      { icon:"📋", title:"Boundary Verification", desc:"Official boundary demarcation with physical markers and GPS coordinate recording.", grad:"from-teal-600 to-teal-700" },
    ],
    features: [
      { icon:"⚡", title:"Fast Service", desc:"Quick turnaround on all survey assignments without compromising accuracy." },
      { icon:"🎯", title:"Accurate Measurement", desc:"100% precision guaranteed with multiple verification checks on every project." },
      { icon:"🤝", title:"Trusted Work", desc:"5000+ satisfied clients across Bihar place their trust in us every year." },
      { icon:"📜", title:"Legal Compliance", desc:"All surveys conform to Bihar land revenue laws and government specifications." },
      { icon:"🛰️", title:"GPS Technology", desc:"State-of-the-art GPS equipment for sub-centimeter accuracy in measurements." },
      { icon:"📞", title:"24/7 Support", desc:"Round-the-clock availability for urgent survey requirements and client queries." },
    ],
    testimonials: [
      { name:"Rajesh Sharma", role:"Property Owner, Patna", text:"Shambhu Kumar ji resolved a 10-year boundary dispute in just 2 days. His expertise and professionalism are unmatched in the region.", rating:5 },
      { name:"Sunita Devi", role:"Farmer, Lakhisarai", text:"We were confused about our agricultural land boundaries. His team came quickly, measured everything correctly, and gave us clear documentation.", rating:5 },
      { name:"Amit Kumar Singh", role:"Builder, Munger", text:"For all our construction projects in Bihar, we always call Shambhu Kumar ji first. 30 years of experience really shows in every survey.", rating:5 },
      { name:"Priya Gupta", role:"Homeowner, Begusarai", text:"The plot verification was done with great precision. All legal documents were prepared correctly. Highly recommend for property transactions.", rating:5 },
      { name:"Ram Prasad", role:"Contractor, Nalanda", text:"Reliable, honest, and always on time. Have used his services for 5+ projects. Best land surveyor in entire Bihar region.", rating:5 },
    ],
    footerDesc: "30+ years of trusted land surveying services across Bihar. Precise, legal, and reliable survey solutions.",
    footerLinks: "Quick Links", footerSvc: "Services",
    copyright: "© 2026 Shambhu Kumar — Licensed Land Surveyor (Amin). All rights reserved.",
    mapLabel: "Lakhisarai, Bihar 811311 — Office Location",
    langBtn: "हिंदी",
  },
  hi: {
    navLinks: ["होम","हमारे बारे में","सेवाएं","विशेषताएं","समीक्षाएं","संपर्क"],
    heroTag: "लाइसेंस प्राप्त अमीन · बिहार राजस्व विभाग",
    heroSub: "बिहार में 30+ वर्षों के विश्वसनीय भूमि सर्वेक्षण अनुभव के साथ। हर संपत्ति के लिए सटीक माप, कानूनी अनुपालन और विश्वसनीय सेवा की गारंटी।",
    heroCta1: "व्हाट्सएप करें",
    heroCta2: "कॉल करें",
    heroMini: [["5000+","प्रोजेक्ट"],["30+","वर्ष"],["100%","सटीक"],["बिहार","लाइसेंस"]],
    heroTyping: ["भूमि सर्वेक्षण","संपत्ति मापन","सीमा अंकन","प्लॉट सत्यापन"],
    heroExpertIn: "विशेषज्ञ",
    aboutTag: "हमारे बारे में",
    aboutTitle: "परिचय",
    aboutSub: "भूमि सर्वेक्षण में सटीकता, विश्वास और व्यावसायिक उत्कृष्टता की विरासत",
    aboutName: "शम्भू कुमार",
    aboutRole: "लाइसेंस प्राप्त भूमि सर्वेक्षक (अमीन)",
    aboutHeading: "बिहार के सबसे विश्वसनीय भूमि सर्वेक्षक",
    aboutP1: (y) => <>30+ <strong className="text-blue-500">वर्षों</strong> की समर्पित सेवा के साथ, शम्भू कुमार (अमीन) ने बिहार में सबसे विश्वसनीय भूमि सर्वेक्षक के रूप में अपनी पहचान बनाई है।</>,
    aboutP2: "बिहार राजस्व विभाग द्वारा लाइसेंस प्राप्त, वे हर असाइनमेंट में सटीकता, ईमानदारी और गति लाते हैं।",
    aboutBadges: [["🏆","सरकारी लाइसेंस प्राप्त"],["📍","लखीसराय, बिहार"],["⚖️","राजस्व विभाग प्रमाणित"],["🌏","पूरे बिहार में सेवा"]],
    svcTag: "हमारी सेवाएं", svcTitle: "हमारी", svcTitleSpan: "सेवाएं",
    svcSub: "व्यक्तियों, बिल्डरों और सरकारी निकायों के लिए व्यापक भूमि सर्वेक्षण समाधान",
    featTag: "हमें क्यों चुनें", featTitle: "हमारे", featTitleSpan: "फायदे",
    testiTag: "ग्राहक अनुभव", testiTitle: "ग्राहक", testiTitleSpan: "क्या कहते हैं",
    contactTag: "संपर्क करें", contactTitle: "संपर्क", contactTitleSpan: "करें",
    contactInfo: "संपर्क जानकारी",
    contactSubText: "नीचे दिए किसी भी माध्यम से संपर्क करें।",
    tapCall: "कॉल करें", chatWA: "व्हाट्सएप पर चैट", emailLbl: "ईमेल", addrLbl: "कार्यालय पता",
    addrText: <>विद्यापीठ चौक, कृष्णा नगर<br/>वार्ड नं. 2, शांति खुंज भवन<br/>लखीसराय, बिहार 811311, भारत</>,
    sendMsg: "संदेश भेजें",
    namePh: "आपका पूरा नाम *", phonePh: "फोन नंबर *", emailPh: "ईमेल (वैकल्पिक)", msgPh: "आपका संदेश या प्रश्न *",
    sendBtn: "व्हाट्सएप से भेजें", sentMsg: "✅ संदेश भेज दिया!",
    statLabels: ["पूर्ण प्रोजेक्ट","वर्षों का अनुभव","संतुष्ट ग्राहक","सटीकता दर"],
    services: [
      { icon:"🗺️", title:"भूमि सर्वेक्षण", desc:"आधुनिक उपकरणों और पारंपरिक विशेषज्ञता का उपयोग करके सटीक सीमा सर्वेक्षण।", grad:"from-blue-600 to-blue-700" },
      { icon:"📐", title:"संपत्ति मापन", desc:"आवासीय और व्यावसायिक संपत्तियों के लिए सटीक क्षेत्रफल गणना।", grad:"from-emerald-600 to-emerald-700" },
      { icon:"🧭", title:"प्लॉट मैपिंग", desc:"कानूनी दस्तावेज़ीकरण सहायता के साथ विस्तृत स्थलाकृतिक और भूकर मानचित्रण।", grad:"from-blue-700 to-indigo-700" },
      { icon:"📋", title:"सीमा सत्यापन", desc:"भौतिक मार्करों और GPS समन्वय रिकॉर्डिंग के साथ आधिकारिक सीमा सीमांकन।", grad:"from-teal-600 to-teal-700" },
    ],
    features: [
      { icon:"⚡", title:"त्वरित सेवा", desc:"सटीकता से बिना समझौता किए सभी सर्वेक्षण कार्यों पर त्वरित टर्नअराउंड।" },
      { icon:"🎯", title:"सटीक माप", desc:"हर प्रोजेक्ट पर कई सत्यापन जांच के साथ 100% सटीकता की गारंटी।" },
      { icon:"🤝", title:"विश्वसनीय कार्य", desc:"5000+ संतुष्ट ग्राहक हर साल हम पर भरोसा करते हैं।" },
      { icon:"📜", title:"कानूनी अनुपालन", desc:"सभी सर्वेक्षण बिहार भूमि राजस्व कानूनों के अनुरूप हैं।" },
      { icon:"🛰️", title:"GPS तकनीक", desc:"उप-सेंटीमीटर सटीकता के लिए अत्याधुनिक GPS उपकरण।" },
      { icon:"📞", title:"24/7 सहायता", desc:"तत्काल सर्वेक्षण आवश्यकताओं और ग्राहक प्रश्नों के लिए चौबीस घंटे उपलब्धता।" },
    ],
    testimonials: [
      { name:"राजेश शर्मा", role:"संपत्ति मालिक, पटना", text:"शम्भू कुमार जी ने सिर्फ 2 दिनों में 10 साल पुराने सीमा विवाद को सुलझाया। उनकी विशेषज्ञता और व्यावसायिकता अतुलनीय है।", rating:5 },
      { name:"सुनीता देवी", role:"किसान, लखीसराय", text:"हम अपनी कृषि भूमि की सीमाओं को लेकर भ्रमित थे। उनकी टीम जल्दी आई, सब कुछ सही तरह से मापा और स्पष्ट दस्तावेज़ दिए।", rating:5 },
      { name:"अमित कुमार सिंह", role:"बिल्डर, मुंगेर", text:"बिहार में हमारे सभी निर्माण प्रोजेक्ट के लिए हम हमेशा शम्भू कुमार जी को पहले बुलाते हैं। 30 साल का अनुभव हर सर्वेक्षण में दिखता है।", rating:5 },
      { name:"प्रिया गुप्ता", role:"गृहस्वामी, बेगूसराय", text:"प्लॉट सत्यापन बहुत सटीकता से किया गया। सभी कानूनी दस्तावेज़ सही तरह से तैयार किए गए। संपत्ति लेनदेन के लिए अत्यधिक अनुशंसित।", rating:5 },
      { name:"राम प्रसाद", role:"ठेकेदार, नालंदा", text:"विश्वसनीय, ईमानदार और हमेशा समय पर। 5+ प्रोजेक्ट के लिए उनकी सेवाओं का उपयोग किया। पूरे बिहार क्षेत्र में सर्वश्रेष्ठ भूमि सर्वेक्षक।", rating:5 },
    ],
    footerDesc: "बिहार में 30+ वर्षों की विश्वसनीय भूमि सर्वेक्षण सेवाएं। सटीक, कानूनी और विश्वसनीय सर्वेक्षण समाधान।",
    footerLinks: "त्वरित लिंक", footerSvc: "सेवाएं",
    copyright: "© 2026 शम्भू कुमार — लाइसेंस प्राप्त भूमि सर्वेक्षक (अमीन)। सर्वाधिकार सुरक्षित।",
    mapLabel: "लखीसराय, बिहार 811311 — कार्यालय स्थान",
    langBtn: "English",
  }
};
 
/* ── HOOKS ── */
function useScrollProgress() {
  const [p, setP] = useState(0);
  useEffect(() => {
    const h = () => {
      const el = document.documentElement;
      const pct = (el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100;
      setP(isNaN(pct) ? 0 : pct);
    };
    window.addEventListener("scroll", h, { passive:true });
    return () => window.removeEventListener("scroll", h);
  }, []);
  return p;
}
 
function useInView(threshold=0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } }, { threshold });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}
 
function useCountUp(end, duration=2000, active=false) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    let cur = 0;
    const step = end / (duration / 16);
    const t = setInterval(() => {
      cur = Math.min(cur + step, end);
      setVal(Math.floor(cur));
      if (cur >= end) clearInterval(t);
    }, 16);
    return () => clearInterval(t);
  }, [active, end, duration]);
  return val;
}
 
function useTyping(words, speed=80, pause=2000) {
  const [text, setText] = useState("");
  const [wi, setWi] = useState(0);
  const [ci, setCi] = useState(0);
  const [del, setDel] = useState(false);
  useEffect(() => {
    const word = words[wi];
    const timer = setTimeout(() => {
      if (!del) {
        setText(word.slice(0, ci + 1));
        if (ci + 1 === word.length) { setTimeout(() => setDel(true), pause); return; }
        setCi(c => c + 1);
      } else {
        setText(word.slice(0, ci - 1));
        if (ci - 1 === 0) { setDel(false); setCi(0); setWi(w => (w + 1) % words.length); return; }
        setCi(c => c - 1);
      }
    }, del ? speed / 2 : speed);
    return () => clearTimeout(timer);
  }, [text, wi, ci, del, words, speed, pause]);
  return text;
}
 
/* ── FADE IN ── */
function FadeIn({ children, delay=0, dir="up", className="" }) {
  const [ref, inView] = useInView(0.1);
  const hidden = dir==="up" ? "opacity-0 translate-y-8" : dir==="left" ? "opacity-0 -translate-x-8" : "opacity-0 translate-x-8";
  return (
    <div ref={ref} className={`transition-all duration-700 ease-out ${inView ? "opacity-100 translate-y-0 translate-x-0" : hidden} ${className}`}
      style={{ transitionDelay:`${delay}ms` }}>
      {children}
    </div>
  );
}
 
function StatCard({ stat, active, label }) {
  const val = useCountUp(stat.end, 2000, active);
  return (
    <div className="text-center">
      <div className="text-4xl md:text-5xl font-bold text-white">{val.toLocaleString()}<span className="text-blue-300">{stat.suffix}</span></div>
      <div className="text-blue-200 mt-2 text-xs tracking-widest uppercase">{label || stat.label}</div>
    </div>
  );
}
 
/* ══════════════════════════════════════════════════════
   FUTURISTIC HERO BACKGROUND SVG
══════════════════════════════════════════════════════ */
function FuturisticBG() {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Deep space base */}
      <div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse 120% 80% at 70% 40%, #0a1628 0%, #020d1a 40%, #010810 100%)"
      }}/>
 
      {/* Animated SVG layer */}
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
        <defs>
          {/* Glow filters */}
          <filter id="glow-blue" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="3" result="blur"/>
            <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
          <filter id="glow-green" x="-30%" y="-30%" width="160%" height="160%">
            <feGaussianBlur stdDeviation="6" result="blur"/>
            <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
          <filter id="glow-strong" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="12" result="blur"/>
            <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
          <filter id="blur-soft">
            <feGaussianBlur stdDeviation="1.5"/>
          </filter>
          {/* Grid gradient */}
          <linearGradient id="grid-fade" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#0a1628" stopOpacity="1"/>
            <stop offset="30%" stopColor="#0a1628" stopOpacity="0.3"/>
            <stop offset="60%" stopColor="#0a1628" stopOpacity="0"/>
            <stop offset="100%" stopColor="#0a1628" stopOpacity="0"/>
          </linearGradient>
          <linearGradient id="scanline-grad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#00d4ff" stopOpacity="0"/>
            <stop offset="50%" stopColor="#00d4ff" stopOpacity="0.4"/>
            <stop offset="100%" stopColor="#00d4ff" stopOpacity="0"/>
          </linearGradient>
          <linearGradient id="terrain-grad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#0d4a3a" stopOpacity="0.9"/>
            <stop offset="50%" stopColor="#0a3028" stopOpacity="0.7"/>
            <stop offset="100%" stopColor="#020d1a" stopOpacity="1"/>
          </linearGradient>
          <linearGradient id="horizon-glow" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#00d4ff" stopOpacity="0"/>
            <stop offset="30%" stopColor="#00d4ff" stopOpacity="0.08"/>
            <stop offset="50%" stopColor="#00ff88" stopOpacity="0.12"/>
            <stop offset="70%" stopColor="#00d4ff" stopOpacity="0.08"/>
            <stop offset="100%" stopColor="#00d4ff" stopOpacity="0"/>
          </linearGradient>
          <radialGradient id="surveyor-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#00d4ff" stopOpacity="0.3"/>
            <stop offset="100%" stopColor="#00d4ff" stopOpacity="0"/>
          </radialGradient>
          <radialGradient id="map-center-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#00ff88" stopOpacity="0.25"/>
            <stop offset="60%" stopColor="#00d4ff" stopOpacity="0.08"/>
            <stop offset="100%" stopColor="#00d4ff" stopOpacity="0"/>
          </radialGradient>
          <radialGradient id="planet-grad" cx="40%" cy="35%" r="60%">
            <stop offset="0%" stopColor="#0d3b5e"/>
            <stop offset="100%" stopColor="#020d1a"/>
          </radialGradient>
          <clipPath id="scene-clip">
            <rect width="1920" height="1080"/>
          </clipPath>
        </defs>
 
        <g clipPath="url(#scene-clip)">
 
          {/* ── BACKGROUND STARS ── */}
          {[
            [120,80],[340,50],[560,120],[780,40],[950,90],[1180,60],[1400,110],[1650,70],[1800,140],
            [200,200],[450,180],[700,230],[900,160],[1100,220],[1350,170],[1580,240],[1750,190],
            [80,350],[300,320],[520,380],[760,310],[1000,360],[1250,300],[1500,370],[1700,330],
            [160,480],[400,450],[640,500],[880,430],[1120,490],[1370,440],[1620,510],[1860,460],
            [240,620],[480,580],[720,640],[960,570],[1200,630],[1450,590],[1700,650],
          ].map(([x,y],i) => (
            <circle key={i} cx={x} cy={y} r={Math.random()*1.2+0.3} fill="white" opacity={0.2+Math.random()*0.5}>
              <animate attributeName="opacity" values={`${0.2+Math.random()*0.3};${0.7+Math.random()*0.3};${0.2+Math.random()*0.3}`}
                dur={`${2+Math.random()*4}s`} repeatCount="indefinite" begin={`${Math.random()*3}s`}/>
            </circle>
          ))}
 
          {/* ── TERRAIN / LANDSCAPE ── */}
          {/* Far mountains */}
          <path d="M700,680 L820,560 L880,610 L960,520 L1050,580 L1120,490 L1200,560 L1280,500 L1380,570 L1460,510 L1560,580 L1640,530 L1720,590 L1800,540 L1920,610 L1920,1080 L700,1080 Z"
            fill="#041520" opacity="0.9"/>
          {/* Mid hills with terrain gradient */}
          <path d="M800,750 L880,680 L940,720 L1020,650 L1100,700 L1180,640 L1260,690 L1360,630 L1440,680 L1520,620 L1600,670 L1700,630 L1800,680 L1920,640 L1920,1080 L800,1080 Z"
            fill="url(#terrain-grad)"/>
          {/* Ground plane */}
          <path d="M750,820 Q1300,780 1920,800 L1920,1080 L750,1080 Z" fill="#041a0f" opacity="0.8"/>
 
          {/* ── PERSPECTIVE GRID ON GROUND ── */}
          {/* Horizontal lines (perspective) */}
          {[0.82,0.86,0.90,0.94,0.98].map((y,i) => {
            const yp = y * 1080;
            const spread = (y - 0.78) * 3000;
            return (
              <line key={`hg${i}`} x1={960-spread} y1={yp} x2={960+spread} y2={yp}
                stroke="#00d4ff" strokeWidth={0.4 - i*0.04} opacity={0.35 - i*0.04}
                filter="url(#blur-soft)"/>
            );
          })}
          {/* Vertical lines (converging to horizon) */}
          {[-7,-5,-3,-1.5,-0.5,0,0.5,1.5,3,5,7].map((v,i) => {
            const horizon = { x:1280, y:830 };
            const bottom = 1080;
            const bx = horizon.x + v * 180;
            return (
              <line key={`vg${i}`} x1={horizon.x} y1={horizon.y} x2={bx} y2={bottom}
                stroke={Math.abs(v)<0.8 ? "#00ff88" : "#00d4ff"}
                strokeWidth={Math.abs(v)<0.8 ? 0.8 : 0.35}
                opacity={Math.abs(v)<0.8 ? 0.7 : 0.3}
                filter="url(#blur-soft)"/>
            );
          })}
 
          {/* ── MAIN DIGITAL MAP OVERLAY (right side) ── */}
          {/* Outer glow */}
          <ellipse cx="1280" cy="580" rx="380" ry="340" fill="url(#map-center-glow)"/>
 
          {/* Hexagonal map grid cells */}
          {[
            [1150,440],[1230,420],[1310,440],[1390,420],[1470,440],
            [1110,490],[1190,470],[1270,490],[1350,470],[1430,490],[1510,470],
            [1130,540],[1210,520],[1290,540],[1370,520],[1450,540],
            [1090,590],[1170,570],[1250,590],[1330,570],[1410,590],[1490,570],
            [1150,640],[1230,620],[1310,640],[1390,620],[1470,640],
            [1190,690],[1270,670],[1350,690],[1430,670],
          ].map(([cx,cy],i) => {
            const size = 32;
            const pts = Array.from({length:6},(_,k)=>{
              const a = Math.PI/180 * (60*k - 30);
              return `${cx+size*Math.cos(a)},${cy+size*Math.sin(a)}`;
            }).join(" ");
            const isHighlight = [3,8,14,19,24].includes(i);
            return (
              <g key={`hex${i}`}>
                <polygon points={pts}
                  fill={isHighlight ? "#00d4ff" : "none"}
                  fillOpacity={isHighlight ? 0.08 : 0}
                  stroke={isHighlight ? "#00ff88" : "#00d4ff"}
                  strokeWidth={isHighlight ? 0.9 : 0.45}
                  strokeOpacity={isHighlight ? 0.9 : 0.4}/>
                {isHighlight && (
                  <polygon points={pts} fill="#00ff88" fillOpacity="0.05"
                    stroke="#00ff88" strokeWidth="0.5" strokeOpacity="0.7"
                    filter="url(#glow-blue)"/>
                )}
              </g>
            );
          })}
 
          {/* Contour lines - land survey style */}
          <path d="M1100,500 Q1200,460 1320,480 Q1420,500 1480,550 Q1440,600 1340,620 Q1220,640 1130,600 Q1080,560 1100,500Z"
            fill="none" stroke="#00d4ff" strokeWidth="0.6" strokeOpacity="0.5" strokeDasharray="4,3"/>
          <path d="M1130,510 Q1210,475 1310,492 Q1400,512 1450,555 Q1420,598 1330,614 Q1225,632 1145,597 Q1102,564 1130,510Z"
            fill="none" stroke="#00ff88" strokeWidth="0.5" strokeOpacity="0.4" strokeDasharray="3,4"/>
          <path d="M1160,520 Q1225,492 1305,505 Q1378,522 1420,558 Q1398,594 1322,608 Q1232,624 1162,593 Q1122,568 1160,520Z"
            fill="none" stroke="#00d4ff" strokeWidth="0.4" strokeOpacity="0.35" strokeDasharray="2,5"/>
 
          {/* Property boundary rectangles */}
          <rect x="1145" y="510" width="90" height="65" fill="none" stroke="#00ff88" strokeWidth="1" strokeOpacity="0.7" strokeDasharray="3,2"/>
          <rect x="1245" y="498" width="110" height="80" fill="none" stroke="#00d4ff" strokeWidth="1" strokeOpacity="0.8"/>
          <rect x="1365" y="515" width="80" height="60" fill="none" stroke="#00ff88" strokeWidth="0.8" strokeOpacity="0.6" strokeDasharray="4,2"/>
          <rect x="1155" y="585" width="95" height="55" fill="none" stroke="#00d4ff" strokeWidth="0.8" strokeOpacity="0.6"/>
          <rect x="1260" y="590" width="105" height="50" fill="none" stroke="#00ff88" strokeWidth="1" strokeOpacity="0.7" strokeDasharray="2,3"/>
 
          {/* Measurement lines with arrows */}
          <line x1="1145" y1="505" x2="1235" y2="505" stroke="#00d4ff" strokeWidth="0.8" strokeOpacity="0.9" filter="url(#glow-blue)"/>
          <polygon points="1235,502 1242,505 1235,508" fill="#00d4ff" opacity="0.9"/>
          <polygon points="1145,502 1138,505 1145,508" fill="#00d4ff" opacity="0.9"/>
 
          <line x1="1145" y1="510" x2="1145" y2="575" stroke="#00ff88" strokeWidth="0.8" strokeOpacity="0.9" filter="url(#glow-blue)"/>
          <polygon points="1142,575 1145,582 1148,575" fill="#00ff88" opacity="0.9"/>
 
          {/* GPS/Coordinate markers */}
          {[[1190,545],[1300,535],[1400,548],[1205,612],[1315,605]].map(([x,y],i) => (
            <g key={`gps${i}`}>
              <circle cx={x} cy={y} r="4" fill="#00d4ff" opacity="0.9" filter="url(#glow-blue)">
                <animate attributeName="r" values="3;5;3" dur={`${1.5+i*0.3}s`} repeatCount="indefinite"/>
                <animate attributeName="opacity" values="0.6;1;0.6" dur={`${1.5+i*0.3}s`} repeatCount="indefinite"/>
              </circle>
              <circle cx={x} cy={y} r="8" fill="none" stroke="#00d4ff" strokeWidth="0.5" opacity="0.4">
                <animate attributeName="r" values="6;14;6" dur={`${2+i*0.4}s`} repeatCount="indefinite"/>
                <animate attributeName="opacity" values="0.5;0;0.5" dur={`${2+i*0.4}s`} repeatCount="indefinite"/>
              </circle>
              <line x1={x-6} y1={y} x2={x+6} y2={y} stroke="#00d4ff" strokeWidth="0.5" opacity="0.7"/>
              <line x1={x} y1={y-6} x2={x} y2={y+6} stroke="#00d4ff" strokeWidth="0.5" opacity="0.7"/>
            </g>
          ))}
 
          {/* Coordinate labels */}
          <text x="1140" y="445" fill="#00ff88" fontSize="9" opacity="0.8" fontFamily="monospace">25°09'N</text>
          <text x="1140" y="458" fill="#00d4ff" fontSize="9" opacity="0.8" fontFamily="monospace">86°05'E</text>
          <text x="1380" y="445" fill="#00ff88" fontSize="9" opacity="0.8" fontFamily="monospace">PLOT: BH-4782</text>
          <text x="1380" y="458" fill="#00d4ff" fontSize="9" opacity="0.8" fontFamily="monospace">AREA: 2.4 Ha</text>
 
          {/* Scanning beam */}
          <line x1="1280" y1="420" x2="1280" y2="720" stroke="#00ff88" strokeWidth="1.5" opacity="0.6" filter="url(#glow-green)">
            <animateTransform attributeName="transform" type="rotate" from="0 1280 570" to="30 1280 570" dur="3s" repeatCount="indefinite" additive="sum"/>
            <animate attributeName="opacity" values="0.3;0.8;0.3" dur="3s" repeatCount="indefinite"/>
          </line>
 
          {/* ── TECH RINGS ── */}
          <circle cx="1280" cy="570" r="200" fill="none" stroke="#00d4ff" strokeWidth="0.5" strokeOpacity="0.3" strokeDasharray="8,4">
            <animateTransform attributeName="transform" type="rotate" from="0 1280 570" to="360 1280 570" dur="20s" repeatCount="indefinite"/>
          </circle>
          <circle cx="1280" cy="570" r="260" fill="none" stroke="#00ff88" strokeWidth="0.4" strokeOpacity="0.2" strokeDasharray="12,6">
            <animateTransform attributeName="transform" type="rotate" from="360 1280 570" to="0 1280 570" dur="30s" repeatCount="indefinite"/>
          </circle>
 
          {/* ── SURVEYOR SILHOUETTE ── */}
          <g transform="translate(1050, 690)" filter="url(#glow-blue)">
            {/* Glow halo */}
            <ellipse cx="60" cy="200" rx="80" ry="20" fill="#00d4ff" opacity="0.15" filter="url(#glow-strong)"/>
            {/* Body */}
            <ellipse cx="60" cy="195" rx="28" ry="55" fill="#00d4ff" opacity="0.12"/>
            {/* Legs */}
            <rect x="45" y="220" width="14" height="55" rx="6" fill="#001833" stroke="#00d4ff" strokeWidth="0.8" strokeOpacity="0.7"/>
            <rect x="62" y="222" width="14" height="53" rx="6" fill="#001833" stroke="#00d4ff" strokeWidth="0.8" strokeOpacity="0.7"/>
            {/* Boots */}
            <ellipse cx="52" cy="274" rx="12" ry="6" fill="#001020" stroke="#00d4ff" strokeWidth="0.6" strokeOpacity="0.8"/>
            <ellipse cx="69" cy="274" rx="12" ry="6" fill="#001020" stroke="#00d4ff" strokeWidth="0.6" strokeOpacity="0.8"/>
            {/* Torso / jacket */}
            <path d="M35,165 Q35,145 60,142 Q85,145 85,165 L85,225 Q70,230 60,230 Q50,230 35,225 Z"
              fill="#001a2e" stroke="#00d4ff" strokeWidth="0.8" strokeOpacity="0.8"/>
            {/* Vest stripes */}
            <path d="M48,158 L48,225" stroke="#f59e0b" strokeWidth="2.5" strokeOpacity="0.7"/>
            <path d="M72,158 L72,225" stroke="#f59e0b" strokeWidth="2.5" strokeOpacity="0.7"/>
            {/* Arms */}
            <path d="M35,170 Q18,180 12,200 Q10,215 18,220" fill="none" stroke="#00d4ff" strokeWidth="8" strokeLinecap="round" strokeOpacity="0.8"/>
            <path d="M85,170 Q100,178 108,192 Q115,205 110,218" fill="none" stroke="#00d4ff" strokeWidth="8" strokeLinecap="round" strokeOpacity="0.8"/>
            {/* Hands */}
            <circle cx="18" cy="220" r="6" fill="#001833" stroke="#00d4ff" strokeWidth="0.8" strokeOpacity="0.8"/>
            <circle cx="110" cy="218" r="6" fill="#001833" stroke="#00d4ff" strokeWidth="0.8" strokeOpacity="0.8"/>
            {/* Head */}
            <circle cx="60" cy="130" r="20" fill="#001a2e" stroke="#00d4ff" strokeWidth="1" strokeOpacity="0.9"/>
            {/* Hard hat */}
            <path d="M38,128 Q38,108 60,105 Q82,108 82,128 L80,132 Q60,136 40,132 Z"
              fill="#f59e0b" stroke="#d97706" strokeWidth="0.8"/>
            <path d="M34,130 L86,130" stroke="#d97706" strokeWidth="2" strokeOpacity="0.8"/>
            {/* Face shield glow */}
            <ellipse cx="60" cy="128" rx="14" ry="12" fill="#00d4ff" opacity="0.08"/>
            {/* Eyes - glowing */}
            <circle cx="54" cy="128" r="2.5" fill="#00d4ff" opacity="0.9" filter="url(#glow-blue)">
              <animate attributeName="opacity" values="0.6;1;0.6" dur="2.5s" repeatCount="indefinite"/>
            </circle>
            <circle cx="66" cy="128" r="2.5" fill="#00d4ff" opacity="0.9" filter="url(#glow-blue)">
              <animate attributeName="opacity" values="0.6;1;0.6" dur="2.5s" repeatCount="indefinite" begin="0.3s"/>
            </circle>
            {/* Neck */}
            <rect x="53" y="148" width="14" height="14" rx="4" fill="#001a2e" stroke="#00d4ff" strokeWidth="0.5" strokeOpacity="0.6"/>
 
            {/* Total Station Tripod */}
            <g transform="translate(95, 155)">
              {/* Instrument head */}
              <rect x="-18" y="-18" width="36" height="22" rx="4" fill="#001830" stroke="#00ff88" strokeWidth="1.2" strokeOpacity="0.9"/>
              <rect x="-12" y="-14" width="24" height="10" rx="2" fill="#002840" stroke="#00d4ff" strokeWidth="0.8" strokeOpacity="0.8"/>
              {/* Lens */}
              <circle cx="10" cy="-9" r="5" fill="#002840" stroke="#00ff88" strokeWidth="1" strokeOpacity="0.9" filter="url(#glow-blue)">
                <animate attributeName="opacity" values="0.7;1;0.7" dur="1.5s" repeatCount="indefinite"/>
              </circle>
              <circle cx="10" cy="-9" r="3" fill="#00ff88" opacity="0.3"/>
              {/* Tripod legs */}
              <line x1="0" y1="4" x2="-30" y2="80" stroke="#00d4ff" strokeWidth="2" strokeOpacity="0.8" strokeLinecap="round"/>
              <line x1="0" y1="4" x2="0" y2="82" stroke="#00d4ff" strokeWidth="2" strokeOpacity="0.8" strokeLinecap="round"/>
              <line x1="0" y1="4" x2="28" y2="80" stroke="#00d4ff" strokeWidth="2" strokeOpacity="0.8" strokeLinecap="round"/>
              {/* Feet */}
              <ellipse cx="-30" cy="82" rx="5" ry="3" fill="#00d4ff" opacity="0.7"/>
              <ellipse cx="0" cy="84" rx="5" ry="3" fill="#00d4ff" opacity="0.7"/>
              <ellipse cx="28" cy="82" rx="5" ry="3" fill="#00d4ff" opacity="0.7"/>
              {/* Laser beam from instrument */}
              <line x1="15" y1="-9" x2="180" y2="-45" stroke="#00ff88" strokeWidth="1" strokeOpacity="0.6"
                strokeDasharray="3,2" filter="url(#glow-green)">
                <animate attributeName="strokeOpacity" values="0.3;0.9;0.3" dur="2s" repeatCount="indefinite"/>
              </line>
              {/* Beam endpoint dot */}
              <circle cx="180" cy="-45" r="3" fill="#00ff88" opacity="0.8" filter="url(#glow-green)">
                <animate attributeName="r" values="2;5;2" dur="2s" repeatCount="indefinite"/>
                <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite"/>
              </circle>
            </g>
 
            {/* Ground shadow */}
            <ellipse cx="60" cy="282" rx="55" ry="8" fill="#00d4ff" opacity="0.08" filter="url(#blur-soft)"/>
          </g>
 
          {/* ── DATA STREAMS / SCAN LINES ── */}
          {[0.2,0.38,0.56,0.74,0.9].map((yp,i) => (
            <rect key={`scan${i}`} x="0" y={yp*1080} width="100%" height="1" fill="url(#scanline-grad)" opacity="0.04">
              <animateTransform attributeName="transform" type="translate" from="0,0" to="0,40" dur={`${6+i*2}s`} repeatCount="indefinite"/>
            </rect>
          ))}
 
          {/* ── FLOATING UI PANELS ── */}
          {/* Top right panel */}
          <g transform="translate(1540, 200)">
            <rect width="200" height="120" rx="4" fill="#000d1a" fillOpacity="0.85" stroke="#00d4ff" strokeWidth="0.8" strokeOpacity="0.7"/>
            <rect width="200" height="20" rx="4" fill="#00d4ff" fillOpacity="0.12"/>
            <text x="8" y="14" fill="#00ff88" fontSize="8" fontFamily="monospace" opacity="0.9">◉ SURVEY SYSTEM ACTIVE</text>
            <line x1="0" y1="20" x2="200" y2="20" stroke="#00d4ff" strokeWidth="0.5" strokeOpacity="0.5"/>
            <text x="8" y="35" fill="#00d4ff" fontSize="7" fontFamily="monospace" opacity="0.8">GPS_LAT: 25.1540°N</text>
            <text x="8" y="48" fill="#00d4ff" fontSize="7" fontFamily="monospace" opacity="0.8">GPS_LON: 86.0970°E</text>
            <text x="8" y="61" fill="#00ff88" fontSize="7" fontFamily="monospace" opacity="0.9">STATUS: SCANNING...</text>
            {/* Progress bar */}
            <rect x="8" y="70" width="184" height="4" rx="2" fill="#001830" stroke="#00d4ff" strokeWidth="0.4" strokeOpacity="0.5"/>
            <rect x="8" y="70" width="140" height="4" rx="2" fill="#00d4ff" opacity="0.7">
              <animate attributeName="width" values="60;184;60" dur="4s" repeatCount="indefinite"/>
            </rect>
            <text x="8" y="85" fill="#00d4ff" fontSize="7" fontFamily="monospace" opacity="0.7">ACCURACY: ±0.02m</text>
            <text x="8" y="98" fill="#00ff88" fontSize="7" fontFamily="monospace" opacity="0.8">SIGNAL: ████████░░ 82%</text>
            <text x="8" y="113" fill="#00d4ff" fontSize="7" fontFamily="monospace" opacity="0.6">AREA CALC: 2.41 Ha</text>
            {/* Blinking cursor */}
            <rect x="132" y="107" width="5" height="8" fill="#00d4ff" opacity="0.8">
              <animate attributeName="opacity" values="0;1;0" dur="0.8s" repeatCount="indefinite"/>
            </rect>
          </g>
 
          {/* Bottom right panel */}
          <g transform="translate(1600, 780)">
            <rect width="170" height="70" rx="4" fill="#000d1a" fillOpacity="0.85" stroke="#00ff88" strokeWidth="0.8" strokeOpacity="0.6"/>
            <text x="8" y="16" fill="#00ff88" fontSize="7" fontFamily="monospace" opacity="0.9">◉ PLOT VERIFIED</text>
            <text x="8" y="29" fill="#00d4ff" fontSize="7" fontFamily="monospace" opacity="0.8">BH-4782 | Lakhisarai</text>
            <text x="8" y="42" fill="#f59e0b" fontSize="7" fontFamily="monospace" opacity="0.9">REG: AMIN-30YRS-CERT</text>
            <text x="8" y="55" fill="#00ff88" fontSize="7" fontFamily="monospace" opacity="0.8">✓ BOUNDARY CONFIRMED</text>
            <text x="8" y="65" fill="#00d4ff" fontSize="6" fontFamily="monospace" opacity="0.5">2026-03-29 | BIHAR SURVEY DEPT</text>
          </g>
 
          {/* ── HORIZON GLOW ── */}
          <rect x="700" y="800" width="1220" height="40" fill="url(#horizon-glow)"/>
 
          {/* ── LEFT SIDE FADE (to keep text readable) ── */}
          <rect x="0" y="0" width="900" height="1080" fill="url(#grid-fade)"/>
 
          {/* ── VIGNETTE EDGES ── */}
          <radialGradient id="vignette" cx="50%" cy="50%" r="70%">
            <stop offset="0%" stopColor="transparent"/>
            <stop offset="100%" stopColor="#010810" stopOpacity="0.7"/>
          </radialGradient>
          <rect x="0" y="0" width="1920" height="1080" fill="url(#vignette)"/>
 
        </g>
      </svg>
 
      {/* Atmospheric overlay */}
      <div className="absolute inset-0" style={{
        background:"linear-gradient(to right, rgba(1,8,16,0.75) 0%, rgba(1,8,16,0.4) 45%, transparent 70%)"
      }}/>
 
      {/* Top atmospheric haze */}
      <div className="absolute top-0 left-0 right-0 h-40" style={{
        background:"linear-gradient(to bottom, rgba(0,10,30,0.6), transparent)"
      }}/>
 
      {/* Bottom ground haze */}
      <div className="absolute bottom-0 left-0 right-0 h-32" style={{
        background:"linear-gradient(to top, rgba(1,8,16,0.95), transparent)"
      }}/>
    </div>
  );
}
 
/* ── LOADER ── */
function Loader({ done }) {
  return (
    <div className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center transition-all duration-700 ${done ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      style={{ background:"radial-gradient(ellipse at center, #0a1628 0%, #010810 100%)" }}>
      <div className="relative w-20 h-20 mb-6">
        <div className="absolute inset-0 rounded-full border-2 border-blue-900"/>
        <div className="absolute inset-0 rounded-full border-2 border-t-blue-400 border-r-transparent border-b-transparent border-l-transparent animate-spin"/>
        <div className="absolute inset-2 rounded-full border border-t-emerald-400 border-r-transparent border-b-transparent border-l-transparent animate-spin" style={{ animationDuration:"0.7s", animationDirection:"reverse" }}/>
        <div className="absolute inset-0 flex items-center justify-center text-2xl">🗺️</div>
      </div>
      <div className="font-bold text-white text-xl tracking-widest" style={{ fontFamily:"Poppins,sans-serif" }}>Shambhu Kumar</div>
      <div className="text-blue-400 text-xs tracking-[4px] mt-1 uppercase" style={{ fontFamily:"Poppins,sans-serif" }}>Amin · Land Surveyor</div>
      <div className="mt-6 w-48 h-0.5 bg-slate-800 rounded-full overflow-hidden">
        <div className="h-full bg-gradient-to-r from-blue-500 to-emerald-400 rounded-full" style={{ animation:"loadbar 1.8s ease-in-out forwards" }}/>
      </div>
    </div>
  );
}
 
/* ── NAVBAR ── */
function Navbar({ dark, setDark, progress, t, lang, setLang }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", h, { passive:true });
    return () => window.removeEventListener("scroll", h);
  }, []);
  const go = (id) => { setOpen(false); document.getElementById(id.toLowerCase())?.scrollIntoView({ behavior:"smooth" }); };
  const navBg = scrolled ? (dark ? "bg-slate-900/97 shadow-lg shadow-black/40 backdrop-blur-md border-b border-slate-800" : "bg-white/97 shadow-lg shadow-blue-900/8 backdrop-blur-md border-b border-slate-200") : "bg-transparent border-b border-transparent";
  return (
    <>
      <div className="fixed top-0 left-0 z-[998] h-0.5 bg-gradient-to-r from-blue-500 via-blue-400 to-emerald-400 transition-all duration-100" style={{ width:`${progress}%` }}/>
      <nav className={`fixed top-0 left-0 right-0 z-[997] transition-all duration-400 ${navBg}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2.5 cursor-pointer" onClick={() => go("home")}>
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-600 to-emerald-500 flex items-center justify-center text-base shadow-lg shadow-blue-500/30">🗺️</div>
            <div>
              <div className={`font-bold text-sm leading-tight ${scrolled ? (dark ? "text-white" : "text-slate-800") : "text-white"}`}>Shambhu Kumar</div>
              <div className={`text-[9px] tracking-[3px] uppercase ${scrolled ? (dark ? "text-blue-400" : "text-blue-600") : "text-blue-300"}`}>Licensed Amin</div>
            </div>
          </div>
          <div className="hidden md:flex items-center gap-7">
            {t.navLinks.map((l,i) => (
              <button key={l} onClick={() => go(NAV_LINKS[i])}
                className={`text-[11px] font-medium tracking-widest uppercase transition-colors hover:text-blue-400 ${scrolled ? (dark ? "text-slate-300" : "text-slate-600") : "text-white/85"}`}>{l}</button>
            ))}
          </div>
          <div className="flex items-center gap-2.5">
            <button onClick={() => setDark(d => !d)}
              className={`w-9 h-9 rounded-full flex items-center justify-center text-base transition-all ${scrolled ? (dark ? "bg-slate-800 text-yellow-300" : "bg-slate-100 text-slate-600") : "bg-white/10 text-white"} hover:scale-110`}>
              {dark ? "☀️" : "🌙"}
            </button>
            <button onClick={() => setLang(l => l==="en"?"hi":"en")}
              className={`flex items-center gap-1 px-2.5 py-1.5 rounded-full text-[11px] font-semibold tracking-wide border transition-all hover:scale-105 ${scrolled ? (dark ? "bg-slate-800 border-blue-500/50 text-blue-400" : "bg-blue-50 border-blue-300 text-blue-600") : "bg-white/10 border-white/30 text-white"}`}>
              🌐 {t.langBtn}
            </button>
            <a href={WA_URL} target="_blank" rel="noreferrer"
              className="hidden sm:flex items-center gap-1.5 bg-emerald-500 hover:bg-emerald-400 text-white text-[11px] font-semibold px-4 py-2 rounded-full transition-all hover:scale-105 shadow-lg shadow-emerald-500/25">
              <span>💬</span> WhatsApp
            </a>
            <button className="md:hidden p-1.5" onClick={() => setOpen(o => !o)}>
              {[0,1,2].map(i => (
                <div key={i} className={`w-5 h-0.5 mb-1 last:mb-0 transition-all ${scrolled ? (dark ? "bg-white" : "bg-slate-800") : "bg-white"} ${i===0&&open ? "rotate-45 translate-y-1.5" : i===1&&open ? "opacity-0" : i===2&&open ? "-rotate-45 -translate-y-1.5" : ""}`}/>
              ))}
            </button>
          </div>
        </div>
        <div className={`md:hidden overflow-hidden transition-all duration-300 ${open ? "max-h-96" : "max-h-0"} ${dark ? "bg-slate-900 border-t border-slate-800" : "bg-white/98 border-t border-slate-100"}`}>
          <div className="px-4 py-3 flex flex-col gap-0.5">
            {t.navLinks.map((l,i) => (
              <button key={l} onClick={() => go(NAV_LINKS[i])}
                className={`text-left py-2.5 px-3 rounded-lg text-sm font-medium tracking-wide uppercase ${dark ? "text-slate-300 hover:bg-slate-800 hover:text-blue-400" : "text-slate-600 hover:bg-blue-50 hover:text-blue-600"}`}>{l}</button>
            ))}
            {/* Language toggle in mobile menu */}
            <button onClick={() => { setLang(l => l==="en"?"hi":"en"); setOpen(false); }}
              className={`mt-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-sm font-semibold border-2 transition-all ${dark ? "border-blue-500/50 text-blue-400 bg-slate-800" : "border-blue-300 text-blue-600 bg-blue-50"}`}>
              🌐 {lang === "en" ? "हिंदी में देखें" : "Switch to English"}
            </button>
            <a href={WA_URL} target="_blank" rel="noreferrer"
              className="mt-1 flex items-center justify-center gap-2 bg-emerald-500 text-white text-sm font-semibold py-2.5 rounded-xl">
              💬 {lang === "en" ? "Chat on WhatsApp" : "व्हाट्सएप पर चैट"}
            </a>
          </div>
        </div>
      </nav>
    </>
  );
}
 
/* ── HERO ── */
function Hero({ t }) {
  const typed = useTyping(t.heroTyping, 75, 2200);
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <FuturisticBG/>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-10 pt-20 pb-16">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 border border-blue-400/30 bg-blue-500/8 backdrop-blur-sm text-blue-300 text-[10px] font-medium px-4 py-1.5 rounded-full mb-8 tracking-widest uppercase"
            style={{ animation:"hfadeup 0.8s 0.3s both" }}>
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"/>
  {t.heroTag}
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white leading-[1.04] mb-5"
            style={{ animation:"hfadeup 0.9s 0.5s both", textShadow:"0 0 60px rgba(0,212,255,0.2)" }}>
            Professional<br/>
            <span style={{ background:"linear-gradient(90deg, #60a5fa, #34d399)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text" }}>
              Land Survey
            </span><br/>
            Services
          </h1>
          <div className="flex items-center gap-2 mb-5 h-9" style={{ animation:"hfadeup 0.8s 0.7s both" }}>
            <span className="text-slate-300 text-base sm:text-lg">Expert in</span>
            <span className="text-base sm:text-lg font-bold text-blue-300 border-r-2 border-blue-400 pr-1" style={{ animation:"blink 0.8s step-end infinite" }}>{typed}</span>
          </div>
          <p className="text-slate-300/90 text-sm sm:text-base leading-relaxed max-w-lg mb-10"
            style={{ animation:"hfadeup 0.8s 0.9s both", textShadow:"0 1px 8px rgba(0,0,0,0.8)" }}>
{t.heroSub}
          </p>
          <div className="flex flex-wrap gap-3" style={{ animation:"hfadeup 0.8s 1.1s both" }}>
            <a href={WA_URL} target="_blank" rel="noreferrer"
              className="group flex items-center gap-2.5 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold px-7 py-3.5 rounded-xl transition-all hover:scale-105 text-sm shadow-xl shadow-emerald-500/30">
<span className="text-lg">💬</span> {t.heroCta1}
              <span className="group-hover:translate-x-1 transition-transform">→</span>
            </a>
            <a href={PHONE}
              className="flex items-center gap-2.5 bg-white/10 hover:bg-white/18 backdrop-blur-sm text-white border border-white/20 hover:border-white/40 font-semibold px-7 py-3.5 rounded-xl transition-all hover:scale-105 text-sm">
<span className="text-lg">📞</span> {t.heroCta2}
            </a>
          </div>
          {/* Mini stats */}
          <div className="flex flex-wrap gap-5 mt-12" style={{ animation:"hfadeup 0.8s 1.3s both" }}>
{t.heroMini.map(([n,l]) => (
              <div key={l} className="text-center">
                <div className="text-xl font-bold text-blue-300" style={{ textShadow:"0 0 12px rgba(96,165,250,0.6)" }}>{n}</div>
                <div className="text-[10px] text-slate-400 tracking-wider uppercase mt-0.5">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24" style={{ background:"linear-gradient(to top, var(--section-bg, #0f172a), transparent)" }}/>
      {/* Scroll hint */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50">
        <span className="text-[9px] text-slate-400 tracking-[4px] uppercase">Scroll</span>
        <div className="w-px h-8 bg-gradient-to-b from-blue-400 to-transparent" style={{ animation:"scrollpulse 1.8s ease-in-out infinite" }}/>
      </div>
    </section>
  );
}
 
/* ── ABOUT ── */
function About({ dark, t }) {
  const bg = dark ? "bg-slate-900" : "bg-white";
  const txt = dark ? "text-white" : "text-slate-800";
  const sub = dark ? "text-slate-400" : "text-slate-500";
  const card = dark ? "bg-slate-800 border-slate-700" : "bg-blue-50 border-blue-100";
  return (
    <section id="about" className={`py-20 sm:py-28 px-4 ${bg}`}>
      <div className="max-w-6xl mx-auto">
        <FadeIn className="text-center mb-14">
          <span className="text-blue-500 text-[10px] font-semibold tracking-[4px] uppercase">{t.aboutTag}</span>
          <h2 className={`text-3xl sm:text-4xl font-bold mt-2 ${txt}`}>{t.aboutTitle} <span className="text-blue-500">Shambhu Kumar</span></h2>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-emerald-400 mx-auto mt-4 rounded-full"/>
        </FadeIn>
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <FadeIn dir="left">
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl" style={{ background:"linear-gradient(135deg,#0d2744,#0a1f38,#091428)" }}>
                <img
                  src="/father.jpeg"
                  alt="Shambhu Kumar — Licensed Land Surveyor"
                  className="w-full h-72 sm:h-80 object-cover object-top"
                  onError={e => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
                <div className="w-full h-72 sm:h-80 hidden items-center justify-center" style={{ background:"linear-gradient(135deg,#0d2744,#0a1f38,#091428)" }}>
                  <div className="text-center">
                    <div className="text-8xl mb-3">👨‍💼</div>
                    <div className="text-white font-bold text-lg">{t.aboutName}</div>
                    <div className="text-blue-300 text-sm mt-0.5">{t.aboutRole}</div>
                  </div>
                </div>
              </div>
              <div className="absolute bottom-4 left-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-4 py-2.5 rounded-xl shadow-xl">
                <div className="font-extrabold text-2xl">30+</div>
                <div className="text-blue-200 text-xs">{t.aboutRole.split(" ")[0]}</div>
              </div>
              <div className="absolute -top-3 -right-3 w-20 h-20 rounded-full border border-emerald-400/25 bg-emerald-400/5"/>
            </div>
          </FadeIn>
          <div>
            <FadeIn dir="right" delay={80}><h3 className={`text-2xl font-bold mb-4 ${txt}`}>{t.aboutHeading}</h3></FadeIn>
            <FadeIn dir="right" delay={160}><p className={`${sub} leading-relaxed mb-3 text-sm`}>{t.aboutP1("30+")}</p></FadeIn>
            <FadeIn dir="right" delay={240}><p className={`${sub} leading-relaxed mb-6 text-sm`}>{t.aboutP2}</p></FadeIn>
            <div className="grid grid-cols-2 gap-3">
              {t.aboutBadges.map(([ic,txt2],i) => (
                <FadeIn key={txt2} delay={300+i*60}>
                  <div className={`flex items-center gap-2 p-3 rounded-xl border ${card}`}>
                    <span className="text-base">{ic}</span>
                    <span className={`text-xs font-medium ${dark?"text-slate-300":"text-slate-700"}`}>{txt2}</span>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
 
/* ── SERVICES ── */
function Services({ dark, t }) {
  return (
    <section id="services" className={`py-20 sm:py-28 px-4 ${dark?"bg-slate-800":"bg-slate-50"}`}>
      <div className="max-w-6xl mx-auto">
        <FadeIn className="text-center mb-14">
          <span className="text-emerald-500 text-[10px] font-semibold tracking-[4px] uppercase">{t.svcTag}</span>
          <h2 className={`text-3xl sm:text-4xl font-bold mt-2 ${dark?"text-white":"text-slate-800"}`}>{t.svcTitle} <span className="text-blue-500">{t.svcTitleSpan}</span></h2>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-emerald-400 mx-auto mt-4 rounded-full"/>
          <p className={`mt-4 max-w-xl mx-auto text-sm ${dark?"text-slate-400":"text-slate-500"}`}>{t.svcSub}</p>
        </FadeIn>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.services.map((s,i) => (
            <FadeIn key={s.title} delay={i*90}>
              <div className={`group relative rounded-2xl overflow-hidden border h-full transition-all duration-400 hover:-translate-y-2 hover:shadow-2xl ${dark?"bg-slate-900 border-slate-700 hover:border-blue-500/50":"bg-white border-slate-200 hover:border-blue-300"}`}>
                <div className={`h-1 bg-gradient-to-r ${s.grad} group-hover:h-1.5 transition-all`}/>
                <div className="p-6">
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${s.grad} flex items-center justify-center text-xl mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>{s.icon}</div>
                  <h3 className={`font-bold text-sm mb-2 ${dark?"text-white":"text-slate-800"}`}>{s.title}</h3>
                  <p className={`text-xs leading-relaxed ${dark?"text-slate-400":"text-slate-500"}`}>{s.desc}</p>
                </div>
                <div className={`absolute inset-0 bg-gradient-to-br ${s.grad} opacity-0 group-hover:opacity-5 transition-opacity duration-400 pointer-events-none`}/>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
 
/* ── STATS ── */
function StatsSection({ t }) {
  const [ref, inView] = useInView(0.25);
  return (
    <section ref={ref} className="py-16 px-4 relative overflow-hidden" style={{ background:"linear-gradient(135deg, #1d4ed8, #1e40af, #1d4ed8)" }}>
      <div className="absolute inset-0 opacity-8" style={{ backgroundImage:"radial-gradient(circle at 20% 50%, white 1px, transparent 1px)", backgroundSize:"28px 28px" }}/>
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-5 relative z-10">
        {STATS.map((s,i) => <FadeIn key={s.label} delay={i*100}><StatCard stat={s} active={inView} label={t.statLabels[i]}/></FadeIn>)}
      </div>
    </section>
  );
}
 
/* ── FEATURES ── */
function Features({ dark, t }) {
  return (
    <section id="features" className={`py-20 sm:py-28 px-4 ${dark?"bg-slate-900":"bg-white"}`}>
      <div className="max-w-6xl mx-auto">
        <FadeIn className="text-center mb-14">
          <span className="text-blue-500 text-[10px] font-semibold tracking-[4px] uppercase">{t.featTag}</span>
          <h2 className={`text-3xl sm:text-4xl font-bold mt-2 ${dark?"text-white":"text-slate-800"}`}>{t.featTitle} <span className="text-emerald-500">{t.featTitleSpan}</span></h2>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-emerald-400 mx-auto mt-4 rounded-full"/>
        </FadeIn>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.features.map((f,i) => (
            <FadeIn key={f.title} delay={i*80}>
              <div className={`group flex gap-3.5 p-5 rounded-2xl border transition-all hover:-translate-y-1 hover:shadow-xl ${dark?"bg-slate-800 border-slate-700 hover:border-blue-500/40":"bg-slate-50 border-slate-200 hover:border-blue-200"}`}>
                <div className={`w-11 h-11 shrink-0 rounded-xl flex items-center justify-center text-lg border group-hover:scale-110 transition-transform duration-300 ${dark?"bg-blue-500/8 border-blue-500/20":"bg-blue-50 border-blue-100"}`}>{f.icon}</div>
                <div>
                  <h3 className={`font-bold text-sm mb-1 ${dark?"text-white":"text-slate-800"}`}>{f.title}</h3>
                  <p className={`text-xs leading-relaxed ${dark?"text-slate-400":"text-slate-500"}`}>{f.desc}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
 
/* ── TESTIMONIALS ── */
function Testimonials({ dark, t }) {
  const [idx, setIdx] = useState(0);
  const go = useCallback(d => setIdx(i => (i+d+t.testimonials.length)%t.testimonials.length), [t]);
  useEffect(() => { const timer = setInterval(() => go(1), 5000); return () => clearInterval(timer); }, [go]);
  const tItem = t.testimonials[idx];
  return (
    <section id="testimonials" className={`py-20 sm:py-28 px-4 ${dark?"bg-slate-800":"bg-gradient-to-br from-blue-50 to-slate-50"}`}>
      <div className="max-w-3xl mx-auto">
        <FadeIn className="text-center mb-14">
          <span className="text-blue-500 text-[10px] font-semibold tracking-[4px] uppercase">{t.testiTag}</span>
          <h2 className={`text-3xl sm:text-4xl font-bold mt-2 ${dark?"text-white":"text-slate-800"}`}>{t.testiTitle} <span className="text-blue-500">{t.testiTitleSpan}</span></h2>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-emerald-400 mx-auto mt-4 rounded-full"/>
        </FadeIn>
        <div className={`rounded-3xl p-8 sm:p-11 border shadow-xl ${dark?"bg-slate-900 border-slate-700":"bg-white border-slate-200"}`}>
          <div className="text-5xl font-serif mb-5 text-blue-400/25">"</div>
          <p key={idx} className={`text-base sm:text-lg leading-relaxed mb-8 italic ${dark?"text-slate-300":"text-slate-600"}`}>{tItem.text}</p>
          <div className="flex items-center justify-between flex-wrap gap-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-emerald-400 flex items-center justify-center text-white font-bold text-sm shadow-lg">
                {tItem.name.charAt(0)}
              </div>
              <div>
                <div className={`font-bold text-sm ${dark?"text-white":"text-slate-800"}`}>{tItem.name}</div>
                <div className={`text-xs ${dark?"text-slate-400":"text-slate-500"}`}>{tItem.role}</div>
              </div>
            </div>
            <div className="flex gap-0.5">{Array.from({length:tItem.rating}).map((_,i)=><span key={i} className="text-yellow-400 text-sm">★</span>)}</div>
          </div>
        </div>
        <div className="flex items-center justify-center gap-3 mt-6">
          <button onClick={() => go(-1)} className={`w-9 h-9 rounded-full border flex items-center justify-center text-sm transition-all hover:scale-110 ${dark?"border-slate-600 text-slate-400 hover:border-blue-500":"border-slate-300 text-slate-500 hover:border-blue-400"}`}>←</button>
          <div className="flex gap-1.5">
            {t.testimonials.map((_,i) => (
              <button key={i} onClick={() => setIdx(i)}
                className={`rounded-full transition-all duration-300 ${i===idx ? "w-5 h-2 bg-blue-500" : `w-2 h-2 ${dark?"bg-slate-600":"bg-slate-300"}`}`}/>
            ))}
          </div>
          <button onClick={() => go(1)} className={`w-9 h-9 rounded-full border flex items-center justify-center text-sm transition-all hover:scale-110 ${dark?"border-slate-600 text-slate-400 hover:border-blue-500":"border-slate-300 text-slate-500 hover:border-blue-400"}`}>→</button>
        </div>
      </div>
    </section>
  );
}
 
/* ── CONTACT ── */
function Contact({ dark, t }) {
  const [form, setForm] = useState({ name:"", phone:"", msg:"" });
  const [sent, setSent] = useState(false);
  const send = () => {
    if (!form.name||!form.phone||!form.msg) { alert("Please fill all required fields."); return; }
    const text = `Hello, I would like to inquire about your land surveying services.\n\nName: ${form.name}\nPhone: ${form.phone}\nMessage: ${form.msg}`;
    window.open(`https://wa.me/918507226854?text=${encodeURIComponent(text)}`, "_blank");
    setSent(true); setTimeout(() => { setSent(false); setForm({name:"",phone:"",msg:""}); }, 3000);
  };
  const inp = `w-full px-4 py-3 rounded-xl border text-sm outline-none transition-all focus:ring-2 focus:ring-blue-500/30 ${dark?"bg-slate-700 border-slate-600 text-white placeholder-slate-500 focus:border-blue-500":"bg-white border-slate-200 text-slate-800 placeholder-slate-400 focus:border-blue-400"}`;
  return (
    <section id="contact" className={`py-20 sm:py-28 px-4 ${dark?"bg-slate-900":"bg-white"}`}>
      <div className="max-w-6xl mx-auto">
        <FadeIn className="text-center mb-14">
          <span className="text-emerald-500 text-[10px] font-semibold tracking-[4px] uppercase">{t.contactTag}</span>
          <h2 className={`text-3xl sm:text-4xl font-bold mt-2 ${dark?"text-white":"text-slate-800"}`}>{t.contactTitle} <span className="text-blue-500">{t.contactTitleSpan}</span></h2>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-emerald-400 mx-auto mt-4 rounded-full"/>
        </FadeIn>
        <div className="grid lg:grid-cols-2 gap-10 mb-10">
          <FadeIn dir="left">
            <div className="space-y-3">
              {[
                { href:PHONE, icon:"📞", label:t.tapCall, val:PHONE_DISPLAY, col:"blue" },
                { href:WA_URL, icon:"💬", label:t.chatWA, val:PHONE_DISPLAY, col:"emerald" },
                { href:"mailto:85072Shambhusingh@gmail.com", icon:"📧", label:t.emailLbl, val:"85072Shambhusingh@gmail.com", col:"purple" },
              ].map(c => (
                <a key={c.label} href={c.href} target={c.col==="emerald"?"_blank":"_self"} rel="noreferrer"
                  className={`flex items-center gap-3.5 p-4.5 p-4 rounded-2xl border transition-all hover:-translate-x-1 hover:shadow-lg ${dark?"bg-slate-800 border-slate-700":"bg-slate-50 border-slate-200"} hover:border-${c.col}-400/60`}>
                  <div className={`w-11 h-11 rounded-xl bg-${c.col}-500/10 flex items-center justify-center text-xl`}>{c.icon}</div>
                  <div>
                    <div className={`text-[9px] font-semibold tracking-widest uppercase mb-0.5 ${dark?"text-slate-400":"text-slate-500"}`}>{c.label}</div>
                    <div className={`font-bold text-sm ${dark?"text-white":"text-slate-800"}`}>{c.val}</div>
                  </div>
                  <div className={`ml-auto text-xs ${dark?"text-slate-600":"text-slate-400"}`}>→</div>
                </a>
              ))}
              <a href="https://maps.google.com/?q=Vidyapithchowk+Krishna+Nagar+Lakhisarai+Bihar+811311+India" target="_blank" rel="noreferrer"
                className={`flex items-start gap-3.5 p-4 rounded-2xl border transition-all hover:-translate-x-1 hover:shadow-lg hover:border-red-400/50 cursor-pointer ${dark?"bg-slate-800 border-slate-700":"bg-slate-50 border-slate-200"}`}>
                <div className="w-11 h-11 shrink-0 rounded-xl bg-red-500/10 flex items-center justify-center text-xl">📍</div>
                <div>
                  <div className={`text-[9px] font-semibold tracking-widest uppercase mb-0.5 ${dark?"text-slate-400":"text-slate-500"}`}>{t.addrLbl} — 📌 Tap to Open in Maps</div>
                  <div className={`font-semibold text-xs leading-relaxed ${dark?"text-white":"text-slate-800"}`}>{t.addrText}</div>
                </div>
                <div className={`ml-auto text-xs mt-1 ${dark?"text-slate-600":"text-slate-400"}`}>→</div>
              </a>
            </div>
          </FadeIn>
          <FadeIn dir="right">
            <div className={`p-6 sm:p-8 rounded-3xl border ${dark?"bg-slate-800 border-slate-700":"bg-slate-50 border-slate-200"}`}>
              <h3 className={`text-xl font-bold mb-5 ${dark?"text-white":"text-slate-800"}`}>{t.sendMsg}</h3>
              <div className="space-y-3">
                <input className={inp} placeholder={t.namePh} value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))}/>
                <input className={inp} placeholder={t.phonePh} type="tel" value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value}))}/>
                <input className={inp} placeholder={t.emailPh} type="email"/>
                <textarea className={`${inp} h-24 resize-none`} placeholder={t.msgPh} value={form.msg} onChange={e=>setForm(f=>({...f,msg:e.target.value}))}/>
                <button onClick={send}
                  className={`w-full py-3.5 rounded-xl font-bold text-sm tracking-wide flex items-center justify-center gap-2 transition-all hover:scale-[1.02] hover:shadow-xl ${sent?"bg-emerald-500 text-white":"bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white shadow-lg shadow-blue-500/20"}`}>
                  {sent ? t.sentMsg : <><span>💬</span> {t.sendBtn}</>}
                </button>
              </div>
            </div>
          </FadeIn>
        </div>
        <FadeIn>
          <div className={`rounded-3xl overflow-hidden border shadow-xl ${dark?"border-slate-700":"border-slate-200"}`}>
            <div className={`px-4 py-2.5 flex items-center gap-2 border-b ${dark?"bg-slate-800 border-slate-700":"bg-slate-50 border-slate-200"}`}>
              <span>📍</span><span className={`text-xs font-medium ${dark?"text-slate-300":"text-slate-600"}`}>{t.mapLabel}</span>
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3488.17070697838!2d86.10232597538156!3d25.189806877715768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f22313e818b451%3A0xe5f2aa8ddbbff4ba!2sShambhu%20Kumar%20%E2%80%93%20Licensed%20Land%20Surveyor%20(Amin)!5e1!3m2!1sen!2sin!4v1774859358349!5m2!1sen!2sin"
              width="100%" height="320" style={{border:0,display:"block"}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Office Location"/>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
 
/* ── FOOTER ── */
function Footer({ dark, t }) {
  const go = id => document.getElementById(id)?.scrollIntoView({ behavior:"smooth" });
  return (
    <footer className="pt-12 pb-5 px-4 bg-slate-950 border-t border-slate-800">
      <div className="max-w-6xl mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-600 to-emerald-500 flex items-center justify-center text-base">🗺️</div>
              <div>
                <div className="font-bold text-white text-sm">Shambhu Kumar</div>
                <div className="text-blue-400 text-[9px] tracking-[3px] uppercase">Licensed Amin · Bihar</div>
              </div>
            </div>
            <p className="text-slate-400 text-xs leading-relaxed max-w-xs mb-4">{t.footerDesc}</p>
            <div className="flex gap-2.5">
              <a href={WA_URL} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center text-emerald-400 hover:bg-emerald-500 hover:text-white transition-all text-sm">💬</a>
              <a href={PHONE} className="w-9 h-9 rounded-full bg-blue-500/10 border border-blue-500/30 flex items-center justify-center text-blue-400 hover:bg-blue-500 hover:text-white transition-all text-sm">📞</a>
            </div>
          </div>
          <div>
            <h4 className="text-white text-[10px] font-semibold tracking-widest uppercase mb-4">{t.footerLinks}</h4>
            {t.navLinks.map((l,i) => <button key={l} onClick={() => go(NAV_LINKS[i].toLowerCase())} className="block text-slate-400 hover:text-blue-400 text-xs mb-2 transition-colors text-left">{l}</button>)}
          </div>
          <div>
            <h4 className="text-white text-[10px] font-semibold tracking-widest uppercase mb-4">{t.footerSvc}</h4>
            {t.services.map(s => <div key={s.title} className="text-slate-400 text-xs mb-2">{s.icon} {s.title}</div>)}
          </div>
        </div>
        <div className="border-t border-slate-800 pt-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] text-slate-600">
          <span>{t.copyright}</span>
          <span>Bihar, India</span>
        </div>
      </div>
    </footer>
  );
}
 
/* ── FLOAT BUTTONS ── */
function FloatBtns() {
  const [show, setShow] = useState(false);
  useEffect(() => { const h = () => setShow(window.scrollY>300); window.addEventListener("scroll",h,{passive:true}); return () => window.removeEventListener("scroll",h); }, []);
  return (
    <div className={`fixed bottom-5 right-5 z-50 flex flex-col items-end gap-2.5 transition-all duration-400 ${show?"opacity-100 translate-y-0":"opacity-0 translate-y-3 pointer-events-none"}`}>
      <button onClick={() => window.scrollTo({top:0,behavior:"smooth"})}
        className="w-9 h-9 rounded-full bg-slate-700/90 hover:bg-slate-600 text-white border border-slate-600 flex items-center justify-center text-sm transition-all hover:scale-110 backdrop-blur-sm shadow-lg">↑</button>
      <a href={PHONE} className="w-11 h-11 rounded-full bg-blue-600 hover:bg-blue-500 text-white flex items-center justify-center text-lg transition-all hover:scale-110 shadow-xl shadow-blue-500/30" style={{animation:"phonepulse 2.5s ease-in-out infinite"}}>📞</a>
      <a href={WA_URL} target="_blank" rel="noreferrer" className="w-13 w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-400 text-white flex items-center justify-center text-2xl transition-all hover:scale-110 shadow-xl shadow-emerald-500/35" style={{animation:"wapulse 3s ease-in-out infinite"}}>💬</a>
    </div>
  );
}
 
/* ── APP ── */
export default function App() {
  const [loaded, setLoaded] = useState(false);
  const [dark,   setDark]   = useState(false);
  const [lang,   setLang]   = useState("en");
  const progress = useScrollProgress();
  const tr = T[lang];
  useEffect(() => { const timer = setTimeout(() => setLoaded(true), 2200); return () => clearTimeout(timer); }, []);
 
  return (
    <div>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');
        *{font-family:'Poppins',sans-serif}
        html{scroll-behavior:smooth}
        ::-webkit-scrollbar{width:4px}
        ::-webkit-scrollbar-thumb{background:#3b82f6;border-radius:2px}
        @keyframes hfadeup{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        @keyframes blink{0%,100%{border-color:transparent}50%{border-color:#60a5fa}}
        @keyframes scrollpulse{0%,100%{opacity:0.3;transform:scaleY(1)}50%{opacity:0.8;transform:scaleY(1.3)}}
        @keyframes loadbar{from{width:0}to{width:100%}}
        @keyframes wapulse{0%,100%{box-shadow:0 0 0 0 rgba(16,185,129,0.4)}50%{box-shadow:0 0 0 10px rgba(16,185,129,0)}}
        @keyframes phonepulse{0%,100%{box-shadow:0 0 0 0 rgba(59,130,246,0.4)}50%{box-shadow:0 0 0 8px rgba(59,130,246,0)}}
      `}</style>
      <Loader done={loaded}/>
      <div className={`min-h-screen transition-colors duration-300 ${dark?"bg-slate-900":"bg-white"}`}>
        <Navbar dark={dark} setDark={setDark} progress={progress} t={tr} lang={lang} setLang={setLang}/>
        <Hero t={tr}/>
        <About dark={dark} t={tr}/>
        <Services dark={dark} t={tr}/>
        <StatsSection t={tr}/>
        <Features dark={dark} t={tr}/>
        <Testimonials dark={dark} t={tr}/>
        <Contact dark={dark} t={tr}/>
        <Footer dark={dark} t={tr}/>
        <FloatBtns/>
      </div>
    </div>
  );
}